exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ai-generate-modal .ai-gen-upload .ivu-upload{display:inline-block}", ""]);

// exports
